import Vue from 'vue'

window.isObjectEquals = function(a, b, ignoreKeys) {
  if (a === undefined || a === null) {
    if (b === undefined || b === null) {
      return true
    }
    return false
  }
  if (b === undefined || b === null) {
    return false
  }
  if (Object.entries(a).length !== Object.entries(b).length) {
    return false
  }
  for (const propName in a) {
    if (ignoreKeys) {
      let ignore = false
      for (let i = 0; i < ignoreKeys.length; i++) {
        if (ignoreKeys[i] === propName) {
          ignore = true
        }
      }
      if (ignore) {
        continue
      }
    }
    if (typeof a[propName] === 'object') {
      if (!window.isObjectEquals(a[propName], b[propName], ignoreKeys)) {
        return false
      }
    } else if (a[propName] !== b[propName]) {
      return false
    }
  }
  return true
}

window.copyObject = function(obj) {
  if (obj) {
    return JSON.parse(JSON.stringify(obj))
  }
  return undefined
}

window.copyObjectWithoutCirculation = function(obj, cached) {
  if (!cached) {
    cached = []
  }
  if (cached.indexOf(obj) >= 0) {
    return
  }
  cached.push(obj)
  const clone = {}
  for (const i in obj) {
    if (typeof obj[i] === 'object' && obj[i] !== null) {
      clone[i] = window.copyObjectWithoutCirculation(obj[i], cached)
    } else {
      clone[i] = obj[i]
    }
  }
  return clone
}

window.copyObjectWithoutOriginalData = function(obj) {
  const ret = JSON.parse(JSON.stringify(obj))
  for (const key in ret) {
    if (key.endsWith('_original_data')) {
      delete ret[key]
    }
  }
  return ret
}

Vue.mixin({
  methods: {
    isObjectEquals(a, b) {
      return window.isObjectEquals(a, b)
    },
    serialize(obj) {
      if (!obj) return ''

      return Object.keys(obj)
        .reduce((params, key) => {
          // 값이 없을 경우 추가하지 않음.
          if (!obj[key]) return params

          const k = encodeURIComponent(key)
          const v = encodeURIComponent(obj[key])
          params.push(`${k}=${v}`)
          return params
        }, [])
        .join('&')
    }
  }
})

window.getStackTrace = function() {
  const obj = {}
  Error.captureStackTrace(obj, window.getStackTrace)
  return obj.stack
}
